export default __webpack_public_path__ + "static/media/error-404.96ae9a9b.svg";